<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="updateVentasReembolsarPago"
    >
      <header class="m-the-modal-header">
        <h5>REEMBOLSAR PAGO</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <p v-if="Object.values($modal.element.pago).length">
          Se reembolsará
          <span
            v-if="$modal.element.pago.detalle === 'Contado'"
            class="text-transform-lowercase"
          >
            el pago de contado de
          </span>
          <span
            v-else-if="$modal.element.pago.detalle.includes('Cuota')"
            class="text-transform-lowercase"
          >
            el pago de la {{ $modal.element.pago.detalle }} de
          </span>
          <span
            v-else
            class="text-transform-lowercase"
          >
            el {{ $modal.element.pago.detalle }} de
          </span>
          <span class="font-weight-bold"> {{ $modal.element.pago.divisa }} {{ $modal.element.pago.monto.toFixed(2) }}</span>
          <span class="text-color-black-35"> {{ $modal.element.pago.divisa_iso_code }} </span>
          con {{ $modal.element.pago.medio_pago }}
        </p>
        <small class="font-weight-bold text-color-danger">
          Esta acción no podrá ser revertida.
        </small>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction cancel-text="CANCELAR"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingMySalesModalRefundPayment',
  data () {
    return {
      buttonPrimary: {
        action: 'REEMBOLSAR',
        class: 'a-button-billing-primary',
        sending: false,
        type: 'submit'
      }
    }
  },
  methods: {
    updateVentasReembolsarPago () {
      this.buttonPrimary.sending = true
      this.$services.update('ventas', 'updateVentasReembolsarPago', null, [this.$route.params.subid ? this.$route.params.subid : this.$modal.element.invoice.venta, this.$modal.element.pago.id_pago ? this.$modal.element.pago.id_pago : this.$modal.element.invoice.pago])
        .then(response => {
          if (this.$modal.element.pago.medio_pago === 'Paypal' || (this.$modal.element.invoice && this.$modal.element.invoice.medio_pago === 'Paypal')) {
            window.open(`${response.data}`)
          } else if (this.$modal.element.pago.medio_pago_manual) {
            this.$alerts.pushAlert('mEditionBillingMySalesRecord', 'updateVentasReembolsarPago', 'success')
          } else {
            this.$alerts.pushAlert('mEditionBillingMySalesRecord', 'updateVentasReembolsarPago', 'successGateway')
          }
          this.buttonPrimary.sending = false
          this.$modal.closeModal()
          this.$modal.updateData()
        })
        .catch(error => {
          console.log(error)
          this.$alerts.pushAlert('mEditionBillingMySalesRecord', 'updateVentasReembolsarPago', 'error', 'a-alert-danger')
          this.buttonPrimary.sending = false
          this.$modal.closeModal()
        })
    }
  }
}
</script>
